
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("8stxP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $6287db2f82387905$var$_jquery = $6287db2f82387905$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $6287db2f82387905$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $6287db2f82387905$var$breadcrumbDots = '<li class="breadcrumb-dots" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots" viewBox="0 0 16 16"><path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/></svg><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16"><path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/></svg></span>';
var $6287db2f82387905$var$init = module.exports.init = function init() {
    var $container = (0, $6287db2f82387905$var$_jquery["default"])(".breadcrumb");
    function checkBreadcrumbs() {
        var $items = $container.find("li");
        var containerWidth = $container[0].offsetWidth;
        var itemsWidth = 35;
        var isShort = false;
        var shouldUpdate = false;
        $container.removeClass("open").removeClass("shortened");
        $container.find(".br-open").removeClass("br-open");
        $items.each(function(index) {
            itemsWidth += $items[index].offsetWidth;
        });
        shouldUpdate = itemsWidth > containerWidth;
        if (shouldUpdate) $items.each(function(index) {
            if (index < 2) return;
            if (index === $items.length - 1) return;
            var item = $items[index];
            if (shouldUpdate) {
                if (!(0, $6287db2f82387905$var$_jquery["default"])(item).hasClass(".sr-only")) {
                    (0, $6287db2f82387905$var$_jquery["default"])(item).addClass("sr-only");
                    isShort;
                }
            }
            itemsWidth = 35;
            $items.each(function(index) {
                itemsWidth += $items[index].offsetWidth;
            });
            shouldUpdate = itemsWidth > containerWidth;
        });
        isShort = $container.find(".sr-only").length > 0;
        if (isShort) $container.addClass("shortened");
    }
    (0, $6287db2f82387905$var$_jquery["default"])($6287db2f82387905$var$breadcrumbDots).insertAfter(".breadcrumb li:first-child");
    $container.addClass("init");
    $container.find(".breadcrumb-dots").on("click", function() {
        if (!$container.hasClass("open")) {
            $container.find(".sr-only").addClass("br-open").removeClass("sr-only");
            $container.addClass("open");
        } else {
            $container.find(".br-open").addClass("sr-only").removeClass("br-open");
            $container.removeClass("open");
        }
    });
    checkBreadcrumbs();
    (0, $6287db2f82387905$var$_jquery["default"])(window).on("resize", function() {
        checkBreadcrumbs();
    });
};

});


//# sourceMappingURL=breadcrumbs.module.b18ae7d9.js.map
